import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosResponse } from "axios"
import { TEnquiryFormValues } from "../../models/enquiry"
import { TCreateEnquiryResponse } from "./types"

/**
 * POST method
 * createEnquiryThunk - Submit the form to create the enquiry and centres
 */
export const createEnquiryThunk = createAsyncThunk(
    'enquiry/createEnquiryThunk',
    async (data: TEnquiryFormValues, { dispatch, rejectWithValue }) => {
      try {
        const response: AxiosResponse<TCreateEnquiryResponse> = await axios.post(`/v1/enquiry`, data)
        return response.data
      } catch (err) {
        return rejectWithValue((err as any).response.data || err)
      }
    }
)